import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { Box, Typography, Stack } from '@mui/material';
import { ChainSvg } from 'assets/images';
import { validationsMessages } from '../../lib';
import { AutocompleteChainSelector } from '../autocomplete-chain-selector';
import {
    chainSelectorDefaults,
    ChainSelectorInputs,
    ChainSelectorSchema,
} from '../chain-selector-modal/chain-selector-modal-helper';
import { chainSelectorStyle } from './chain-selector-helper';

export interface ChainSelectorProps {
    setSelectedChain: Function;
    selectedChain?: string;
    text?: string;
    chain?: string;
    error?: boolean;
    setError?: React.Dispatch<React.SetStateAction<boolean>>;
    isImgHidden?: boolean;
    isDataCreated?: boolean;
}

export const ChainSelector = ({
    selectedChain,
    setSelectedChain,
    chain,
    text,
    error,
    setError,
    isImgHidden = false,
    isDataCreated = false,
}: ChainSelectorProps): React.JSX.Element => {
    const { control } = useForm<ChainSelectorInputs>({
        mode: 'all',
        resolver: yupResolver(ChainSelectorSchema),
        defaultValues: chainSelectorDefaults,
    });

    const location = useLocation();
    const handleChainSelected = (chainParams: string): void =>
        chainParams !== selectedChain && setSelectedChain(chainParams);

    useEffect(() => {
        const prevSelectedChain = chain ?? location?.state;
        if (!isDataCreated && prevSelectedChain) {
            setSelectedChain(prevSelectedChain);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chain, setSelectedChain]);

    const onAutocompleteChange = (__: any, value: string): void => {
        handleChainSelected(value);
        setError?.(false);
    };

    return (
        <Box sx={chainSelectorStyle.mainBoxStyle}>
            <Stack sx={chainSelectorStyle.displayFlex}>
                <Box>
                    {!selectedChain || !isImgHidden ? (
                        <>
                            <Box sx={chainSelectorStyle.nestedBoxStyle}>
                                <img
                                    alt='Under development'
                                    src={ChainSvg}
                                    style={chainSelectorStyle.imgStyle}
                                />
                            </Box>
                            <Box>
                                <Typography
                                    variant='h2'
                                    sx={{
                                        ...chainSelectorStyle.typoStyle,
                                        mb: isDataCreated ? 2 : 4,
                                    }}
                                >
                                    {text}
                                </Typography>
                            </Box>
                        </>
                    ) : (
                        <></>
                    )}
                </Box>
                <Box sx={chainSelectorStyle.textAlignCenter}>
                    <AutocompleteChainSelector
                        control={control}
                        controlName='chain'
                        tooltipTitle={selectedChain ?? ''}
                        selectedChain={selectedChain}
                        handleOnChange={onAutocompleteChange}
                        error={error}
                        errorText={error ? validationsMessages.required : ''}
                        autocompleteStyles={
                            chainSelectorStyle.chainAutocomplete
                        }
                    />
                </Box>
            </Stack>
        </Box>
    );
};
